<template>
  <div class="textarea_autogrow__container">
    <textarea
      :id="id"
      ref="textarea"
      class="autogrow"
      :value="value"
      :required="required"
      :placeholder="placeholder"
      :aria-valid="ariaValid"
      :aria-errormessage="ariaErrormessage"
      rows="1"
      autocomplete="off"
      @input="onInput"
      @keydown.enter.exact="onEnter"
    />
    <div ref="hiddenDiv" class="textarea_autogrow__hidden_div">&nbsp;</div>
  </div>
</template>

<script>
const resize = function (textarea, hiddenDiv) {
  /*
  Copy the textarea contents to the hidden div. This will make the textarea container grow
  and the textarea will also grow, as it's set to height: 100%.
  Adding '&nbsp;' solves an initial mismatch in height when the line is empty.
  */
  hiddenDiv.innerHTML = textarea.value.replace(/\n/g, '<br/>') + '&nbsp;'
}

export default {
  name: 'TextareaAutogrow',
  props: {
    onInput: { type: Function, required: true },
    id: { type: String, required: true },
    value: { type: String, required: true },
    ariaValid: { type: String, required: true },
    required: { type: String, default: null },
    ariaErrormessage: { type: String, default: null },
    placeholder: { type: String, default: null },
    shouldSubmitOnEnter: { type: Boolean, default: false },
    onSubmit: { type: Function, default: null }
  },
  mounted() {
    resize(this.$refs.textarea, this.$refs.hiddenDiv)
  },
  updated() {
    resize(this.$refs.textarea, this.$refs.hiddenDiv)
  },
  methods: {
    onEnter(event) {
      if (this.shouldSubmitOnEnter) {
        event.preventDefault()
        this.onSubmit()
      }
    }
  }
}
</script>
